// React และ Routing
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import withRouter from '../withRouter';

// HTTP client
import axios from 'axios';

// Bootstrap Components
import {
    Container,
    Nav,
    Navbar,
    NavDropdown,
    Row,
    Col,
    Card,
    Image as BootstrapImage
} from 'react-bootstrap';

// RSuite UI Components
import {
    Button,
    Loader,
    ButtonGroup
} from 'rsuite';

// Third-party libraries
import Swal from 'sweetalert2';
import moment from 'moment-timezone';

class DashboardPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            logged: null,
            isMobile: window.innerWidth <= 768,
            content: null,
            modal: null,
        };
    }

    async componentDidMount() {
        let logged = null;

        try {
            const stored = localStorage.getItem('logged');
            if (stored) {
                logged = JSON.parse(stored);
            }
        } catch (error) {
            console.error('Error parsing "logged" from localStorage:', error);
            logged = null; // fallback
        }

        try {
            const announceResponse = await axios.get(`${process.env.REACT_APP_API}/announce/1`);
            const announceData = announceResponse.data[0];

            this.setState({ logged }, () => {
                this.onRenderContent({ mode: 'read', loggedData: logged, announceData });
            });
        } catch (error) {
            console.error('Error fetching announcement data:', error);
            this.setState({ logged }, () => {
                this.onRenderContent({ mode: 'read', loggedData: logged, announceData: null });
            });
        }
    }

    handleLogout = () => {
        // ลบข้อมูลล็อกอิน
        localStorage.removeItem('logged');


        window.location.href = '/';
    };


    promisedSetState = (newState) => {
        return new Promise(resolve => this.setState(newState, resolve));
    };

    onRenderContent = async ({ mode, loggedData, announceData }) => {
        if (mode === 'read') {
            await this.promisedSetState({
                content: (
                    <Container fluid>

                        <Navbar expand="lg" style={{ backgroundColor: '#8a0a0a' }} data-bs-theme="dark">
                            <Navbar.Toggle aria-controls="basic-navbar-nav" />
                            <Navbar.Collapse id="basic-navbar-nav">
                                <Nav className="me-auto">
                                    <Row>
                                        <Col>  {/* ชิดซ้าย */}

                                            {/* ปุ่มประกาศทุน */}
                                            <Button
                                                href={`./results/2569`}
                                                target="_blank"
                                                size="md"
                                                appearance="link"
                                                style={{
                                                    color: '#ffffffc2',          // ตัวหนังสือสีขาว
                                                    fontWeight: '700',         // ตัวหนังสือหนา
                                                    textDecoration: 'none',
                                                    fontSize: '1.3rem'
                                                }}
                                                startIcon={
                                                    <span
                                                        style={{
                                                            backgroundColor: '#ff9e43ff',   // สีแดง
                                                            padding: '6px',
                                                            borderRadius: '50%',
                                                            display: 'inline-flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        }}
                                                    >
                                                        <i
                                                            className="bi bi-megaphone-fill"
                                                            style={{ color: '#ffffff' }}
                                                        ></i>
                                                    </span>
                                                }
                                            >
                                                ประกาศผู้ได้รับทุนการศึกษา ปีการศึกษา 2569
                                            </Button>

                                            {/* ปุ่มวิธีสมัคร */}
                                            <Button
                                                href={`${process.env.REACT_APP_UPLOAD}/uploads/announce/J4FRZ2w5Nj.pdf`}
                                                target="_blank"
                                                size="md"
                                                appearance="link"
                                                style={{
                                                    color: '#ffffffc2',          // ตัวหนังสือสีขาว
                                                    fontWeight: '700',         // ตัวหนังสือหนา
                                                    textDecoration: 'none',
                                                    fontSize: '1.3rem'
                                                }}
                                                startIcon={
                                                    <span
                                                        style={{
                                                            backgroundColor: '#ffffff83',   // สีเทา
                                                            padding: '6px',
                                                            borderRadius: '50%',
                                                            display: 'inline-flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        }}
                                                    >
                                                        <i
                                                            className="bi bi-journal-text"
                                                            style={{ color: '#ffffff' }}
                                                        ></i>
                                                    </span>
                                                }
                                            >
                                                วิธีสมัครขอรับทุนการศึกษา
                                            </Button>

                                        </Col>
                                    </Row>
                                </Nav>
                            </Navbar.Collapse>

                            <Navbar>
                                <Nav>
                                    <Nav.Item style={{ display: 'flex', alignItems: 'center' }}>
                                        <Button
                                            as={Link}
                                            to="/form_register"
                                            size="lg"
                                            appearance="primary"
                                            style={{
                                                backgroundColor: 'transparent',
                                                color: '#ffffff',
                                                border: 'none',
                                                boxShadow: 'inset 0 0 0 1px #ffffff',
                                                boxSizing: 'border-box',
                                                padding: '0.375rem 1rem',
                                                fontWeight: 500,
                                                transition: 'all 0.3s ease',
                                                borderRadius: 3,
                                            }}
                                            onMouseEnter={e => {
                                                e.currentTarget.style.backgroundColor = '#ffffff';
                                                e.currentTarget.style.color = '#8a0a0a';
                                            }}
                                            onMouseLeave={e => {
                                                e.currentTarget.style.backgroundColor = 'transparent';
                                                e.currentTarget.style.color = '#ffffff';
                                            }}
                                        >
                                            สมัครสมาชิก
                                        </Button>
                                    </Nav.Item>

                                    {!loggedData || loggedData.login !== 'successfully' ? (
                                        <Nav.Item as={Link} to="/login">
                                            <Button
                                                size="lg"
                                                appearance="primary"
                                                startIcon={<i className="bi bi-person-fill"></i>}
                                                style={{
                                                    backgroundColor: 'white',
                                                    color: '#8a0a0a',
                                                    border: '4px solid #8a0a0a',
                                                    boxSizing: 'border-box',
                                                    padding: '0.375rem 1rem',
                                                }}
                                            >
                                                ลงชื่อเข้าใช้งาน
                                            </Button>
                                        </Nav.Item>
                                    ) : (
                                        <Nav>
                                            <NavDropdown
                                                title={
                                                    <span>
                                                        <i class="bi bi-person-circle me-2"></i>
                                                        {loggedData.user.user.first_name} {loggedData.user.user.last_name}
                                                    </span>
                                                }
                                                id="user-nav-dropdown"
                                                align="end"
                                            >
                                                <NavDropdown.Item onClick={this.handleLogout}>ออกจากระบบ</NavDropdown.Item>
                                            </NavDropdown>
                                        </Nav>
                                    )}

                                </Nav>
                            </Navbar>

                        </Navbar>

                        {announceData.is_image === true && (
                            <BootstrapImage
                                className="border"
                                src={`${process.env.REACT_APP_UPLOAD}/${announceData.path}`}
                                fluid
                                width={'100%'}
                            />
                        )}

                        {announceData.text !== '' && <Row className="justify-content-center mb-2">
                            <Col md={12} lg={12}>
                                <Card style={{ padding: '0.5em', border: '1px solid #ccc', borderRadius: '2px' }}>
                                    <pre>{announceData.text}</pre>
                                </Card>
                            </Col>
                        </Row>}

                        <Row className="d-flex justify-content-center mt-2">
                            <Col className="text-center">
                                <Button
                                    href={`${process.env.REACT_APP_UPLOAD}/uploads/announce/J4FRZ2w5Nj.pdf`}
                                    target="_blank"
                                    size="md"
                                    appearance="subtle"
                                    startIcon={<i className="bi bi-megaphone"></i>}
                                >
                                    กรุณาอ่านประกาศรับสมัครขอรับทุนการศึกษา
                                </Button>
                            </Col>
                        </Row>

                        <Row className="d-flex justify-content-center mt-2">
                            <Col className="text-center">
                                <ButtonGroup vertical={this.state.isMobile} style={this.state.isMobile ? { width: '100%' } : {}} >
                                    <Button
                                        className='text-center'
                                        size='md'
                                        color='green'
                                        appearance='primary'
                                        startIcon={<i className="bi bi-pencil-square"></i>}
                                        style={{ borderRadius: '5px', marginBottom: '0.5em', marginBottom: '0.5em', marginRight: '0.5em' }} // 0.5em spacing
                                        onClick={async () => {
                                            const responseStatus = await axios.get(`${process.env.REACT_APP_API}/status/1`);
                                            if (responseStatus.data[0].status) {
                                                // Fetch data from the API
                                                const responseYear = await axios.get(`${process.env.REACT_APP_API}/default/${responseStatus.data[0].default_year}`);

                                                // Parse start_date
                                                const start_date = moment.tz(`${responseYear.data.rows[0].start_date} 00:00`, 'YYYY-MM-DD HH:mm', 'Asia/Bangkok').toDate();

                                                // Parse and modify end_date in one step
                                                const end_date = moment.tz(`${responseYear.data.rows[0].end_date} 00:00`, 'YYYY-MM-DD HH:mm', 'Asia/Bangkok')
                                                    .add(1, 'minute')
                                                    .add(1, 'day')
                                                    .toDate();

                                                // Check if the current date and time is between start_date and end_date
                                                if (start_date && end_date && moment().tz('Asia/Bangkok').isBetween(start_date, end_date)) {

                                                    const loggedData = JSON.parse(localStorage.getItem('logged'));

                                                    if (!loggedData || loggedData.login !== 'successfully') {
                                                        await Swal.fire({
                                                            title: "กรุณาลงชื่อเข้าใช้งาน",
                                                            html: `<i class="bi bi-person-fill" style="font-size: 10rem; color: #0d6efd;"></i>`,
                                                            showConfirmButton: false,
                                                            timer: 2000,
                                                            timerProgressBar: true,
                                                        });
                                                    } else if (loggedData || loggedData.login == 'successfully') {
                                                        window.location.href = './form_apply';
                                                        return;
                                                    }



                                                } else {
                                                    const formatToThaiDate = (dateString) => {
                                                        const thaiMonths = [
                                                            "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน",
                                                            "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"
                                                        ];

                                                        const date = new Date(dateString);
                                                        const day = date.getDate();
                                                        const month = thaiMonths[date.getMonth()];
                                                        const year = date.getFullYear() + 543; // Convert from AD to BE (Buddhist Era)

                                                        return `${day} ${month} ${year}`;
                                                    };

                                                    const startDate = responseYear.data.rows[0].start_date;
                                                    const endDate = responseYear.data.rows[0].end_date;

                                                    const formattedStartDate = formatToThaiDate(startDate);
                                                    const formattedEndDate = formatToThaiDate(endDate);

                                                    Swal.fire({
                                                        title: `<div>ระบบเปิดรับสมัคร<br/>วันที่ ${formattedStartDate} ถึง ${formattedEndDate}</div>`,
                                                        icon: "error",
                                                        confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                                                    });
                                                }
                                            } else {
                                                Swal.fire({
                                                    title: `<div>ระบบปิดรับสมัคร</div>`,
                                                    icon: "error",
                                                    confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                                                });
                                            }
                                        }}
                                    >
                                        สำหรับผู้ที่สนใจสมัครทุนการศึกษา
                                    </Button>

                                    <Button
                                        className='text-center'
                                        size='md'
                                        color='blue'
                                        appearance='primary'
                                        startIcon={<i className="bi bi-person-fill"></i>}
                                        style={{ borderRadius: '5px' }} // 0.5em spacing
                                        onClick={async () => {
                                            if (!loggedData || loggedData.login !== 'successfully') {
                                                await Swal.fire({
                                                    title: "กรุณาลงชื่อเข้าใช้งาน",
                                                    html: `<i class="bi bi-person-fill" style="font-size: 10rem; color: #0d6efd;"></i>`,
                                                    showConfirmButton: false,
                                                    timer: 2000,
                                                    timerProgressBar: true,
                                                });
                                            } else {
                                                try {
                                                    const response = await axios.get(`${process.env.REACT_APP_API}/application/latest/${loggedData.user.user.id}`);
                                                    const data = response.data;

                                                    if (data && data.decision_result === true) {
                                                        window.location.href = './profile';
                                                    } else {
                                                        await Swal.fire({
                                                            title: 'สำหรับนักเรียนทุนเท่านั้น',
                                                            icon: "warning",
                                                            timer: 2000,
                                                            timerProgressBar: true,
                                                            confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                                                        });
                                                    }
                                                } catch (error) {
                                                    console.error(error);
                                                    await Swal.fire({
                                                        icon: 'error',
                                                        title: 'เกิดข้อผิดพลาด',
                                                        text: 'ไม่สามารถดึงข้อมูลได้',
                                                        showConfirmButton: true,
                                                    });
                                                }
                                            }
                                        }}
                                    >
                                        สำหรับนักเรียนทุน
                                    </Button>
                                </ButtonGroup>
                            </Col>
                        </Row>
                    </Container>
                )
            })
        }
    }

    render() {

        const FullPageLoader = () => (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(255, 255, 255, 0.8)', // Semi-transparent background
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999 // Ensure it's on top of other content
            }}>
                <Loader content="Loading..." /> {/* Adjust loader component as needed */}
            </div>
        );

        return (
            <>
                {this.state.content}
                {this.state.loading && <FullPageLoader />}
            </>
        );
    }
}

export default withRouter(DashboardPage);
